import { extend, configure } from 'vee-validate';
import { required, email, numeric, alpha_num, length, max, digits } from 'vee-validate/dist/rules';

// Función para validar el curp
import { curpValidate, isOver18, isUnder71 } from "../helpers/validation_functions";

import { fourDigitsYear } from "../helpers/helpers_functions";

configure({
  classes: {
    invalid: ['border-2', 'border-solid', 'border-red']
  }
})

// No message specified.
extend('email', {
  ...email,
  message: 'Email inválido'
});

// Override the default message.
extend('required', {
  ...required,
  message: 'Este campo es requerido'
});

extend('numeric', {
  ...numeric,
  message: 'Este campo debe ser númerico'
});

extend('alpha_num', {
  ...alpha_num,
  message: 'Este campo solo debe tener letras o números'
});

extend('length', {
  ...length,
  message: 'Este campo debe ser de {length} caracteres'
});

extend('max', {
  ...max,
  // params: ['length'],
  message: 'Este campo debe ser de máximo {length} caracteres'
});

extend('digits', {
  ...digits,
  // params: ['length'],
  message: 'Este campo debe ser númerico y debe tener {length} dígitos'
});

extend('alpha_num_spaces', {
  validate: value => {
    let regexp = /^[a-zA-Z0-9\s]+$/;
    return regexp.test(value);
  },
  message: 'Este campo solo debe tener letras, números o espacios'
});

extend('alpha_spaces', {
  validate: value => {
    let regexp = /^[a-zA-Z\s]+$/;
    return regexp.test(value);
  },
  message: 'Este campo solo debe tener letras o espacios'
});

extend('curp', {
    validate: value => {
      return curpValidate(value);
    },
    message: 'CURP inválido'
});

extend('birthdate', {
    validate: value => {
      let birthDate = new Date(value);
      return isOver18(birthDate) && isUnder71(birthDate);
    },
    message: 'Fecha de nacimiento inválida'
});  

extend('month', {
  validate: value => {
    let regexp = /^\d{4}-(0[1-9]|1[0-2])$/;
    return regexp.test(value);
  },
  message: 'El tiempo de residencia debe ser en formato AAAA-MM'
});

extend('first_name_curp', {
  params: ['target'],
  validate: (value, { target }) => {
    return value.charAt(0).toUpperCase() === target.charAt(3);
  },
  message: 'La inicial del nombre debe coincidir con el CURP'
})

extend('last_mname_curp', {
  params: ['target'],
  validate: (value, { target }) => {
    return value.charAt(0).toUpperCase() === target.charAt(2);
  },
  message: 'La inicial del apellido materno debe coincidir con el CURP'
})

extend('last_name_curp', {
  params: ['target'],
  validate: (value, { target }) => {
    const first = value.charAt(0);
    const idx = value.slice(1).search(/[aeiou]/gi);
    const second = value[idx + 1];
    return (first + second).toUpperCase() === target.slice(0,2);
  },
  message: 'La inicial del apellido paterno debe coincidir con el CURP'
})

extend('birthdate_curp', {
  params: ['target'],
  validate: (value, { target }) => {
    let birthDate = target.slice(4, 10);
    birthDate = `${fourDigitsYear(
        parseInt(birthDate.slice(0, 2))
    )}-${birthDate.slice(2, 4)}-${birthDate.slice(4, 6)}`;
    return value === birthDate;
  },
  message: 'La fecha de nacimiento debe coincidir con el CURP'
})

extend('state_curp', {
  params: ['target'],
  validate: (value, { target }) => {
    return value.id === target.slice(11, 13).toUpperCase();
  },
  message: 'El estado debe coincidir con el CURP'
})

extend('gender_curp', {
  params: ['target'],
  validate: (value, { target }) => {
    return value.id === (target.charAt(10) === "H" ? "MALE" : "FEMALE");
  },
  message: 'El género debe coincidir con el CURP'
})